import { NewVersion } from './NewVersion';

export default NewVersion;
